// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import StarEmpty from '../_raw/ui/icon_star_empty.svg';
import withIconProps from '../withIconProps';

export default withIconProps(StarEmpty);
